<template>
    <div class="applepie">
        <span class="hashName" :tooltip="hasher.hash_name">{{hasher.hash_name}}</span>
        <span v-if="editable" class="removeHasher" @click="removeHasher">
            <span class="material-icon">close</span>
        </span>
    </div>
</template>

<script>
  export default {
    name: "EditableHasher",
    props: ['hasher', 'editable'],
    methods: {
      removeHasher() {
        this.$emit('removeHasher', this.hasher);
      }
    }
  }
</script>

<style scoped lang="scss">
    .removeHasher > span {
        //border-right: 1px solid grey;
        font-size: 1.5em;
        width: 1em;
        flex-grow: 0;
        cursor: pointer;
        z-index: 1;
        color: grey;
        padding-left: 0.2em;
    }

    .removeHasher {
        //width: 100%;
        /*background-color: rgba(180, 0, 0, 0.4);*/
        /*background-image: repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.5) 35px, rgba(255,255,255,.5) 70px);*/
        .material-icon {
            vertical-align: middle;
        }
        
    }
    div:hover > .removeHasher {
    }
    div:hover {
    }
    .applepie, .hashName {
        font-size: 0.75rem;
        font-weight: 600;
        width: auto !important;
        padding-top: 0;
        padding-bottom: 0;
        position: relative;
        //top: 50%;
        //margin-top: -1em;
        flex-grow: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .applepie {
        background: brown;
        color: white;
        text-align: center;

    }
</style>
